import { TEnv } from '@ingeniorforeningen/figurine-core';
import { ReactNode, useEffect } from 'react';
import useAppStore from '../../store/appStore';
import { useLocation } from 'react-router-dom';
import { AppLanguage } from '../../types';
import { ROUTE } from '../../App';
import { useIsColumn } from '../../hooks';
import { MitIdaAppShell } from '@ingeniorforeningen/figurine-cms';

interface Props {
  username: string;
  isAuthenticated: boolean;
  children?: ReactNode;
}

const IsDetailsPage = (pathname: string) => {
  return (
    pathname.includes(`${ROUTE.CASE_DETAILS.DANISH}/`) ||
    pathname.includes(`${ROUTE.CASE_DETAILS.ENGLISH}/`)
  );
};

export const AppWrapper = ({ username, isAuthenticated, children }: Props) => {
  const appLanguage = useAppStore((state) => state.appLanguage);
  const fetchTexts = useAppStore((state) => state.fetchTexts);
  const location = useLocation();

  const { isColumn } = useIsColumn();

  useEffect(() => {
    if (isAuthenticated) {
      fetchTexts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appLanguage, isAuthenticated]);

  const setLanguagePath = (defaultPath: string) => {
    const path = location.pathname.split('/');

    if (`/${path[1]}` === ROUTE.CASE_DETAILS.DANISH) {
      return `${ROUTE.CASE_DETAILS.ENGLISH}/${path[2]}`;
    }
    if (`/${path[1]}/${path[2]}` === ROUTE.CASE_DETAILS.ENGLISH) {
      return `${ROUTE.CASE_DETAILS.DANISH}/${path[3]}`;
    }
    return defaultPath;
  };

  return (
    <MitIdaAppShell
      cmsHost={runtimeConfig.umbracoApiUrl}
      env={runtimeConfig.umbracoEnv as TEnv}
      language={appLanguage}
      headerData={{
        user: {
          username,
          role: [],
          links: [
            { text: appLanguage === AppLanguage.English ? 'Log out' : 'Log ud', href: '/logout' },
          ],
        },
        languages: [
          { code: AppLanguage.Danish, href: setLanguagePath('/') },
          { code: AppLanguage.English, href: setLanguagePath('/en') },
        ],
      }}
      hideFooter={isColumn && IsDetailsPage(location.pathname) ? true : false}
      clean={isColumn && IsDetailsPage(location.pathname) ? true : false}
      scrollToTop={false}
    >
      {children}
    </MitIdaAppShell>
  );
};
